import { Injectable, inject } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { UserService } from '../user/user.service';

@Injectable()
export class AuthErrorInterceptor implements HttpInterceptor {
  private router = inject(Router);
  private userService = inject(UserService);

  private signingOut = false;

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((err: HttpErrorResponse) => {
        const fromOurBackend = req.url.startsWith(environment.baseURL);
        if (fromOurBackend && (err.status === 401 || err.status === 403) && !this.signingOut) {
          this.signingOut = true;
          void this.userService.forceTimeoutSignOut(this.router.url);
        }
        return throwError(() => err);
      })
    );
  }
}
